var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: _vm.href } }, [
        _c("img", { attrs: { src: require("@/assets/img/logo_mcd.png") } }),
      ]),
    ]),
    _c("div", { staticClass: "header-right" }, [
      _c(
        "div",
        { staticClass: "header-user-con" },
        [
          _vm._m(0),
          _c(
            "el-dropdown",
            {
              staticClass: "user-name",
              attrs: { trigger: "click" },
              on: { command: _vm.handleCommand },
            },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v(" " + _vm._s(_vm.username) + " "),
                _c("i", { staticClass: "el-icon-caret-bottom" }),
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    { attrs: { divided: "", command: "loginout" } },
                    [_vm._v("退出登录")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-avator" }, [
      _c("span", { staticClass: "fa fa-user-circle-o" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }